import React from 'react';
import Accordion from '../components/Accordion';
import CustomerService from '../components/CustomerService';
import AccountMainLayout from '../Layout/AccountMainLayout';

const Support = () => {
  return (
    <>
      <AccountMainLayout>
        <div className="box-card-price">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-3">
                <CustomerService
                  Title="Give Us a Call:"
                  Customer="Customer Service"
                  Number="346-298-5017"
                  EmergencyTitle="Attorney Hotline Emergency Number"
                  EmergencyNumber="346-298-5017"
                />
              </div>
              <div className="col-md-6 mb-3">
                <div className="first-card-price">
                  <h3 className="call">Contact Emails:</h3>
                  <div className="service">
                    <h3>General</h3>
                    <p>
                      <strong>
                        <a href="mailto:info@mycalibercard.com">
                          info@mycalibercard.com
                        </a>
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Accordion heading="LOOKING FOR INFORMATION?" />
      </AccountMainLayout>
    </>
  );
};

export default Support;
